import React from 'react';

export interface TileProps {
  title?: string;
  image: {
    url: string;
    title: string;
  };
  size: 'large' | 'basic' | 'small';
  url: string;
}

const Tile: React.FC<TileProps> = ({ title, image, size = 'basic', url }) => {
  return (
    <a className={`tile tile--${size}`} href={url}>
      <img src={image.url} alt={image.title} className="tile__image" />
      {size !== 'small' && <h5 className="tile__title">{title}</h5>}
    </a>
  );
};

export default Tile;
